import env from 'env';
import { PODIUM_EMAIL_DOMAIN, PODIUM_MOCK_PHONE } from './constants';

const isPodiumEmail = (email) => {
  const emailArray = email?.split('@');

  if (emailArray?.length < 2) {
    return false;
  } else {
    const emailDomain = emailArray[1];

    return emailDomain === PODIUM_EMAIL_DOMAIN;
  }
};

export const formatUserDetails = (userDetails = {}) => {
  const { email, phone } = userDetails;

  if (!!phone) {
    return userDetails;
  } else {
    const shouldAddMockPhone =
      process.env.NODE_ENV === 'development' || isPodiumEmail(email);

    return {
      ...userDetails,
      phone: shouldAddMockPhone ? PODIUM_MOCK_PHONE : phone,
    };
  }
};

export const redirectUrlAfterPurchase = ({
  redirectUrl,
  shouldRedirectToOnboarding,
} = {}) =>
  !!redirectUrl
    ? redirectUrl
    : shouldRedirectToOnboarding
    ? `${env.KAZAAM_URL}/onboarding/education`
    : env.KAZAAM_URL;
